import { backendApi } from "src/backendApi/backendApi";

import type {
  V3PlayerFilters,
  PlayerActivity,
  PlayerActivityFilters,
  PlayerActivityResponse,
} from "@neuromotion-inc/mightier-ts-sdk";

import { queryOptions } from "@tanstack/react-query";

export const listPlayersQueryOpts = (
  filters: V3PlayerFilters = {},
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
) => {
  return queryOptions({
    queryKey: ["players", "list", filters],
    queryFn: async () => {
      const resp = await backendApi.listPlayers(filters);
      return resp.data;
    },
  });
};

export const retrievePlayerQueryOpts = (
  playerId: number,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
) => {
  return queryOptions({
    queryKey: ["players", "retrieve", playerId],
    queryFn: async () => {
      const resp = await backendApi.retrievePlayer(playerId);
      return resp.data;
    },
  });
};

export class PlayerActivityPatcher {
  private readonly respBody: PlayerActivityResponse;

  constructor(playerActivityPage: PlayerActivityResponse) {
    this.respBody = playerActivityPage;
  }

  patch(): PlayerActivityResponse {
    const ret = {
      ...this.respBody,
      results: this.respBody.results.map((r) => this.processSingleResult(r)),
    };

    return ret;
  }

  private processSingleResult(result: PlayerActivity): PlayerActivity {
    const secondsPlayedDuringGames = result.games_played.reduce((acc, curr) => {
      return acc + curr.seconds_played;
    }, 0);
    const cooldownsDuringGames = result.games_played.reduce((acc, curr) => {
      return acc + curr.num_cooldowns;
    }, 0);

    return {
      ...result,
      games_played: [
        ...result.games_played,
        {
          game_name: "IN_MIGHTIER_WORLD",
          seconds_played: result.seconds_played - secondsPlayedDuringGames,
          num_cooldowns: result.num_cooldowns - cooldownsDuringGames,
        },
      ],
    };
  }
}

export const retrievePlayerActivityQueryOpts = (
  playerId: number,
  filters: PlayerActivityFilters,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
) => {
  return queryOptions({
    queryKey: ["players", "retrieve", playerId, "activity", filters],
    queryFn: async () => {
      const resp = await backendApi.retrievePlayerActivity(playerId);
      return new PlayerActivityPatcher(resp.data).patch();
    },
  });
};
